/* eslint-disable import/prefer-default-export */
import * as Sentry from "@sentry/react";
import ActivityFeedPost from "../apiResources/ActivityFeedPost";
import CurrentUser from "../apiResources/CurrentUser";
import Recruiter from "../apiResources/Recruiter";
import {
  LOAD_ACTIVITY_FEED,
  LOAD_ACTIVITY_FEED_ERROR,
  LOAD_MORE_ACTIVITY_FEED_POSTS,
} from "./types";

const perPageCount = 15;

export const loadActivityFeed = () => async (dispatch) => {
  try {
    const currentUser = await CurrentUser.first();
    const recruiter = await Recruiter.find(currentUser.data.companyId);

    const feedPosts = await ActivityFeedPost.order({
      created_at: "desc",
    })
      .per(perPageCount)
      .stats({ total: "count" })
      .all();

    dispatch({
      type: LOAD_ACTIVITY_FEED,
      payload: {
        isPortalUser: recruiter.data.portal,
        posts: feedPosts.data,
        totalCount: feedPosts.meta.stats.total.count,
        loaded: perPageCount,
      },
    });
  } catch (error) {
    Sentry.captureException(error);

    dispatch({
      type: LOAD_ACTIVITY_FEED_ERROR,
      payload: error,
    });
  }
};

export const loadMorePosts = (page) => async (dispatch) => {
  try {
    const newPosts = await ActivityFeedPost.order({
      created_at: "desc",
    })
      .page(page)
      .per(perPageCount)
      .all();

    dispatch({
      type: LOAD_MORE_ACTIVITY_FEED_POSTS,
      payload: {
        newPosts: newPosts.data,
        perPageCount,
      },
    });
  } catch (error) {
    Sentry.captureException(error);

    dispatch({
      type: LOAD_ACTIVITY_FEED_ERROR,
      payload: error,
    });
  }
};
